import { useDispatch, useSelector } from 'react-redux'
import { Checkbox } from '../../../../common/html/checkbox'
import {
  checkAllItem,
  selectChecked,
  selectIds,
  uncheckAllItem,
} from './store/slice'

const CheckboxAll = () => {
  const dispatch = useDispatch()

  const ids = useSelector(selectIds)
  const checked = useSelector(selectChecked)

  const onChange = (valChecked) => {
    if (valChecked) {
      dispatch(checkAllItem())
    } else {
      dispatch(uncheckAllItem())
    }
  }

  const isChecked = !ids.some((id) => !checked[id])

  return <Checkbox checked={isChecked} onChange={onChange} />
}

export default CheckboxAll
